import { useTonAddress, useTonWallet } from "@tonconnect/ui-react";

import stakingList from "../constants"
import { useEffect } from "react";
import { Stake } from "wrappers/stake";
import { Address, Cell } from "@ton/core";
import { getGlobalPoolData, getUserPoolData } from "store/features/poolsSlice";
import { useDispatch } from "store/store";
import { useGetAssetsQuery, useGetBalancesQuery } from "store/api/dexApiSlice";

export default async function useStakingLoad() {
    const walletAddress = useTonAddress();
    const wallet = useTonWallet();
    const wallet_code = Cell.fromBase64("te6cckECBwEAAZYAART/APSkE/S88sgLAQIBYgMCAEOhPFvaiaH0gAPww/SAA/DF9AAD8Mn0AGHwx/CJ8Ifwg/CFAqbQbCLtRND6QAH4YfpAAfhi+gAB+GT6ADD4YyDHAJFb4AHQ0wMBcbCRW+D6QDD4QgHHBfLgVNMf0z+CEHa/ux5SMLrjAoIQdtdPfRO64wJbhA/y8AYEAegB+gD6ADD4RCK+8uBT+ETCAI5D+EQhqIIQO5rKAKkE+EOhIMIAjiuCEA+8tUnIyx9SQMs/NBP6AvhBzxbJcYAYyMsF+ELPFnD6AstqzMmAQPsAkjAy4pEy4iDCAJb4RAGh+GSRMOL4RAGoghA7msoAqQT4YwUAKMj4Qc8W+ELPFvhE+gL4Q/oCye1UAPRsEvoA+gAw+ETCAI5C+EQhqIIQO5rKAKkE+EOhIMIAjiqCEA+8tUnIyx8Uyz9QA/oC+EHPFslxgBjIywX4Qs8WcPoCy2rMyYBA+wCSMDLikTLi+EQBoPhk+EQBqIIQO5rKAKkE+GPI+EHPFvhCzxb4RPoC+EP6AsntVP2ykj0=")
    const dispatch = useDispatch();
    const {data: assets} = useGetAssetsQuery()


    const getApr = (reward_per_second: number, total_staked: number, quote_dex_price_usd: number, reward_dex_price_usd: number) => {
        const rewardTokensPerYear = reward_per_second * 86400 * 365;
        return rewardTokensPerYear * reward_dex_price_usd * 100/ (total_staked * quote_dex_price_usd);
    }
    useEffect(() => {
       
        const fetchStakingGlobalData = async () => {
            const infos = await Promise.all(stakingList.map((s) => {
                const staking_contract = Stake.createFromAddress(Address.parse(s.address));
                return staking_contract.getJettonData(s.address)
            }))
          
            const globalArray = stakingList.map((stake, index) => {

                const quote_dex_price_usd = (assets && assets[stake.quote.address]) ? assets[stake.quote.address].dex_price_usd : 1.1;
                const reward_dex_price_usd = (assets && assets[stake.reward.address]) ? assets[stake.reward.address].dex_price_usd : 1.1;
                return {
                    ...stake,
                    accTokenPerShare: infos[index].accTokenPerShare,
                    claim_fee: infos[index].claim_fee,
                    deposit_fee: infos[index].deposit_fee,
                    lastRewardTime: infos[index].lastRewardTime,
                    reward_per_second: infos[index].reward_per_second,
                    start_date: infos[index].start_date,
                    total_staked: infos[index].total_staked,
                    quote_dex_price_usd,
                    reward_dex_price_usd,
                    apr: getApr(Number(infos[index].reward_per_second), Number(infos[index].total_staked), quote_dex_price_usd, reward_dex_price_usd)
                }
            })
            dispatch(getGlobalPoolData(globalArray))
        }

        const fetchUserData = async () => {
            const userInfo = await Promise.all(stakingList.map((s) => {
                const wallet_contract = Stake.createWalletAddressFromConfig({
                    ownerAddress: Address.parse(walletAddress),
                    stakeAddress: Address.parse(s.address),
                    walletCode: wallet_code
                }, wallet_code)
                return wallet_contract.getUserStakeWalletData(wallet_contract.address.toString())
            }))
            dispatch(getUserPoolData(userInfo));
        }

        fetchStakingGlobalData()
        if(walletAddress) {
            fetchUserData()
        }

    }, [walletAddress, assets, dispatch, wallet_code])
}